import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { IoIosArrowBack } from 'react-icons/io'
import { useTranslation } from 'react-i18next'
import { useProfileStore } from '../../store/useUserStore';
import { toast } from 'react-toastify';
import api from '../../api/api';
import parse from "html-react-parser";
import { formatDate, isImageFile, isPDFFile } from '../../helpers/helper';

const StudentReportView = () => {
  const navigate = useNavigate()
    const { t } = useTranslation()

    let { reportId } = useParams();
  
    const [studentReport, setStudentReport] = useState<any>([])
    const {setLoading} = useProfileStore();
    
    useEffect(() => {
        if (!reportId) return;
      setLoading(true);
      api
        .get(`${process.env.REACT_APP_API_BASE_URL}/parent/student/report/${reportId}`)
        .then((res) => {
          console.log("res student report", res.data.data);
          setStudentReport(res.data.data);
        })
        .catch((err) => {
          toast.error(err.message || t("server_error"));
          console.log("err student report", err);
        })
        .finally(() => {
          setLoading(false);
        });
    }, []);
    
  return (
    <div>
        {/* Header */}
        <div className='mb-4 grid grid-cols-4 px-4 pt-2'>
            <div><IoIosArrowBack size={28} color='#000' onClick={()=>navigate("/student-report")}/></div>
            <div className='text-center col-span-2 text-lg font-medium'></div>
            <div></div>
        </div>

        {studentReport && (
        <div className="pb-28">
            <div className="grid grid-cols-12 gap-2 p-2.5 items-center ">
                <div className="col-span-3">
                    <img
                        src={studentReport.coach_academy_profile_pic || "/assets/img/koku-logo.png"}
                        alt=""
                        className="w-10 h-10 rounded-3xl"
                    />
                </div>
                <div className=" col-span-9">
                    <div className="text-lg font-semibold">
                        {studentReport.coach_name || "-"}
                    </div>
                    <div className="text-md font-light">
                        {studentReport.created_at ? formatDate(studentReport.created_at) : "-"}
                    </div>
                </div>
            </div>

            <div className="px-3 mt-6 text-xl font-semibold">
                {studentReport.title || "-"}
            </div>

            <div className="px-3 mt-3 text-lg">
                {studentReport.description &&
                              parse(studentReport.description?.replace(/\n/g, "<br />") || "")}
            </div>

            <div className="px-3 mt-3 text-lg">
                {(studentReport.files && studentReport.files.length) >=1 && (
                <div className="space-y-3">
                    {studentReport.files.map(
                    (attachment: any, index: number) => {
                        if (isImageFile(attachment)) {
                        return (
                            <img
                            key={index}
                            src={attachment}
                            alt={`Attachment ${index}`}
                            className="image-class"
                            />
                        );
                        } else if (isPDFFile(attachment)) {
                        return (
                            <a
                            key={index}
                            href={attachment}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-2 p-3 bg-gray-100 rounded-lg hover:bg-gray-200"
                            >
                            <svg
                                className="w-6 h-6 text-red-600"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                            >
                                <path d="M4 18h12V6h-4V2H4v16zm8-14v4h4l-4-4z" />
                            </svg>
                            <span className="text-base">
                                PDF Document {index + 1}
                            </span>
                            </a>
                        );
                        }
                        return null;
                    },
                    )}
                </div>
                )}
            </div>
        </div>)}
    </div>
  );
};

export default StudentReportView;